/**
 * Category filter on the posts listing (template-parts/sections/
 * section-posts-filter.php). Options hold category archive URLs —
 * picking one simply navigates there.
 */
const filterSelect = document.querySelector('.posts-filter__select');

if (filterSelect) {
    filterSelect.addEventListener('change', () => {
        window.location.href = filterSelect.value;
    });
}
